module.exports = __webpack_public_path__ + "853d607a6e6db6f149ae89d28c22b8ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/floatie-donut-s.png
// module id = 1273
// module chunks = 0